import React, { useState } from 'react';
import { Users, GitBranch, CreditCard, Building2, User } from 'lucide-react';
import TeamsManagement from '../teams/TeamsManagement';
import LeadDistributionSettings from './LeadDistributionSettings';
import SubscriptionWrapper from './SubscriptionWrapper';
import OrganizationSettings from './OrganizationSettings';
import UserProfileSettings from './UserProfileSettings';
import Header from '../../components/header';
import './settingsPage.scss';

type SettingsTab = 'teams' | 'distribution' | 'subscription' | 'organization' | 'profile';

const SettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<SettingsTab>('teams');

  const tabs = [
    {
      id: 'organization' as SettingsTab,
      label: 'Organization',
      icon: Building2,
      description: 'Organization settings'
    },
    {
      id: 'profile' as SettingsTab,
      label: 'User Profile',
      icon: User,
      description: 'Personal information'
    },
    {
      id: 'teams' as SettingsTab,
      label: 'Teams',
      icon: Users,
      description: 'Manage team members and roles'
    },
    {
      id: 'distribution' as SettingsTab,
      label: 'Lead Distribution',
      icon: GitBranch,
      description: 'Configure distribution rules'
    },
    {
      id: 'subscription' as SettingsTab,
      label: 'Subscription',
      icon: CreditCard,
      description: 'Plans and billing'
    }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'organization':
        return <OrganizationSettings />;
      case 'profile':
        return <UserProfileSettings />;
      case 'teams':
        return <TeamsManagement />;
      case 'distribution':
        return <LeadDistributionSettings />;
      case 'subscription':
        return <SubscriptionWrapper />;
      default:
        return <TeamsManagement />;
    }
  };

  return (
    <>
      <Header />
      <div className="settings-page-container">
        {/* Settings Header */}
        <div className="settings-header">
          <div className="settings-header-content">
            <h1>Settings</h1>
            <p>Manage your workspace settings and preferences</p>
          </div>
        </div>

      {/* Settings Tabs */}
      <div className="settings-tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <div className="settings-tab-icon">
                <Icon size={20} />
              </div>
              <div className="settings-tab-content">
                <div className="settings-tab-label">{tab.label}</div>
                <div className="settings-tab-description">{tab.description}</div>
              </div>
            </button>
          );
        })}
      </div>

        {/* Settings Content */}
        <div className="settings-content-area">
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default SettingsPage;